// Lazy project-name lookup used by ProjectInput.
// Kept separate so calculator pages can show saved project names without
// pulling Dexie into the initial shared bundle.

function uniqueSorted(values: string[]): string[] {
  const seen = new Set<string>();
  const result: string[] = [];

  for (const value of values) {
    const trimmed = value.trim();
    if (!trimmed || seen.has(trimmed)) continue;
    seen.add(trimmed);
    result.push(trimmed);
  }

  return result.sort((a, b) => a.localeCompare(b));
}

export async function loadAllProjectNames(): Promise<string[]> {
  const { db } = await import('./db');
  const keys = await db.savedPages.orderBy('project').uniqueKeys();
  return uniqueSorted((keys as string[]).map(key => key ?? ''));
}
